"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SZ = void 0;
exports.SZ = {
    numericCode: '748',
    alpha2Code: 'SZ',
    alpha3Code: 'SWZ',
    englishName: {
        short: 'Eswatini',
        full: 'the Kingdom of Eswatini',
    },
    names: {
        full: {
            en: 'the Kingdom of Eswatini',
            fr: 'le Royaume d’Eswatini',
            ss: 'eSwatini',
        },
        short: {
            en: 'Eswatini',
            fr: "Eswatini (l')",
            ss: 'eSwatini',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ss',
            languageAlpha3Code: 'ssw',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'SZ-HH': {
            numericCode: '748',
            code: 'SZ-HH',
            category: {
                id: '166',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Hhohho',
                ss: 'Hhohho',
            },
        },
        'SZ-LU': {
            numericCode: '748',
            code: 'SZ-LU',
            category: {
                id: '166',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Lubombo',
                ss: 'Lubombo',
            },
        },
        'SZ-MA': {
            numericCode: '748',
            code: 'SZ-MA',
            category: {
                id: '166',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Manzini',
                ss: 'Manzini',
            },
        },
        'SZ-SH': {
            numericCode: '748',
            code: 'SZ-SH',
            category: {
                id: '166',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Shiselweni',
                ss: 'Shiselweni',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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